
export class BreadcrumbItem {
  link: string;

  icon: string;

  title: string;

  linkParams: any;

  constructor(title: string, icon: string, link ?: string, linkParams: any = {}) {
    this.title = title;
    this.icon = icon;
    this.link = link;
    this.linkParams = linkParams;
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/entities/misc/breadcrumb-item.entity.ts